<!--
  - Copyright (c) 2024. Haodong JU
  -->

<template>
  <horizontal-list>
    <v-card
      elevation="0"
      @click="addToSelected(t)"
      :color="selected[t]?'amber':'grey lighten-4'"
      :class="selected[t]?'pr-2 px-4':'px-4'"
      v-for="t in tableTypeList"
      :key="t"
      class="pa-2 text-body-1 d-flex align-center"
    >
      {{ t }}
      <template v-if="selected[t]">
        <v-card
          elevation="0"
          class="primary white--text px-2 ml-2"
          @click.stop="removeFromSelected(t)"
        >
          &times;{{ selected[t] }}
        </v-card>
      </template>
    </v-card>
  </horizontal-list>
</template>

<script>
import Table from '@/model/dataLayer/api/tableAndPerson/Table'
import sortBy from 'lodash-es/sortBy'
import { groupBy, uniqBy } from 'lodash'
import HorizontalList from '@/views/widget/uiComponent/HorizontalList.vue'
import { isEqual, times } from 'lodash-es'

export default {
  name: 'TableRequirementEditor',
  components: { HorizontalList },
  props: {
    value: {
      required: true
    }
  },
  data: function () {
    return {
      tableTypeList: [],
      selected: {}
    }
  },
  watch: {
    value (val) {
      const newObj = val
        ? Object.fromEntries(
          Object.entries(groupBy(val, 'seatCount')).map(([key, value]) => [key, value.length]))
        : {}
      if (!isEqual(newObj, this.selected)) {
        this.selected = newObj
      }
    },
    selected: {
      deep: true,
      handler (val) {
        console.log(val, 'selected')
        this.$emit('input', Object.entries(this.selected).map(([seatCount, count]) =>
          times(count).map(it => ({ seatCount }))
        ).flat())
      }
    }
  },
  methods: {
    addToSelected (seatCount) {
      if (this.selected[seatCount]) {
        this.selected[seatCount]++
      } else {
        this.$set(this.selected, seatCount, 1)
        this.selected[seatCount] = 1
      }
    },
    removeFromSelected (seatCount) {
      if (this.selected[seatCount] && this.selected[seatCount] > 1) {
        this.selected[seatCount]--
      } else {
        this.$delete(this.selected, seatCount)
      }
    }
  },
  async mounted () {
    const tableList = (await Table.getList(true))
    this.tableTypeList = sortBy(uniqBy(tableList.map(it => it.seatCount)))
  }
}
</script>

<style scoped>

</style>
